import type { ProductLinkKey } from './productLinks'

export const media = {
  heroBanner:
    'https://cdn.magicpatterns.com/uploads/6uuDK5uQvJX8bmYyQ8DmLi/576227F8-F8A4-4CF6-B534-BEED445C8BA8.png',
  detailSheet:
    'https://cdn.magicpatterns.com/uploads/pzDD4GfN3mgvcypUF4nrpx/9E3F6D27-ECA1-491C-A19D-28C856C7FD7E.png',
  lensSheet:
    'https://cdn.magicpatterns.com/uploads/nkw1BAZWLPjUfNNrJ25BRd/39670657-8A76-439E-9079-591CEA18FDC7.png',
  tradesSheet:
    'https://cdn.magicpatterns.com/uploads/8EQbCvptTyMGvWtQMVi1N9/6565379D-D103-4C24-AA34-60AF3A94D7DC.png',
  versusSheet:
    'https://cdn.magicpatterns.com/uploads/mPQJRpVmK3SeLw1fPpkPo7/C702DD5E-9D73-4242-9837-9BC5A6705F69.png',
  packsSheet:
    'https://cdn.magicpatterns.com/uploads/tUmGMdH9uwnaz14zcQJMuC/0C6A047A-1804-44B2-AF80-3727768F36DF.png',
  struggle: 'https://cdn.magicpatterns.com/patterns/generated-images/764a1124-49cc-46dd-a58f-1314aef79981.jpg',
  /** Real GritVue product photos. */
  x1Smoke: 'https://cdn.magicpatterns.com/uploads/jfZ3V8iLtS6ZzZyZKm9LL5/A1D1F501-7C3F-47B4-BC48-AF2FDAF8AEE9.png',
  lensSet: 'https://cdn.magicpatterns.com/uploads/se7m7BdQ4NQFgpfxyYo7yE/5DD458BB-D6B5-42BA-B2F3-8CC7F9F85268.png',
  completeInCase: 'https://cdn.magicpatterns.com/uploads/qUdcrxZCehECT9q3foJyEt/547B6BFD-AF7A-42B4-9207-7FBC07262406.png',
  hardCase: 'https://cdn.magicpatterns.com/uploads/7k2J2P4XQ6MvcTkkkdymhd/9FA0C683-E6CB-48C1-BD42-66D85670AA9C.png',
  pouchCloth: 'https://cdn.magicpatterns.com/uploads/kbV3y4q431HnXGWYyCnKSH/F58AC6A7-A8B8-47B2-AF20-5FCB2A6B1826.png',
  cable: 'https://cdn.magicpatterns.com/uploads/nE5LMxfTG6JVvAPCfmUwgp/7C3CBB56-1A03-4F73-87F7-35F3E96C9E91.png',
  guideCover: 'https://cdn.magicpatterns.com/uploads/wqWamZK3dsXQuAU9CsYBFe/414DF77D-40A7-4CC3-9C6F-B8E716186EA6.png',
  careKit: 'https://cdn.magicpatterns.com/uploads/q3rFpQ3KgvmBr4EerJNYYh/054F7FC5-CC68-4744-9F2E-1A5294AA9F91.png',
  rxInsert: 'https://cdn.magicpatterns.com/uploads/cCMNWZXWTAtny3DUSvda6C/6A798A6D-D55E-4BFF-87CB-42381F57F695.png',
  mysteryBox: 'https://cdn.magicpatterns.com/uploads/3Ss9zQFnhS9WRhfTMkgugD/6773A62B-3511-4C36-89CA-393DC9ACE266.png',
}

export interface SequenceFrame {
  src: string
  alt: string
  caption: string
}

export const heroSequence: SequenceFrame[] = [
  {
    src: media.heroBanner,
    alt: 'GritVue X1 illuminated work glasses shown with all three lenses',
    caption: 'GritVue X1™. Light where you look.',
  },
  {
    src: media.lensSheet,
    alt: 'The GritVue X1 clear, amber and smoke lenses shown with workers in each condition',
    caption: 'One frame. Three lenses. Any job.',
  },
  {
    src: media.detailSheet,
    alt: 'GritVue X1 detail view of the light module, frame, lenses and charging port',
    caption: 'Dual light sources. USB-C rechargeable.',
  },
  {
    src: media.versusSheet,
    alt: 'A traditional strap headlamp compared against the GritVue X1',
    caption: 'Your headlamp just evolved.',
  },
  {
    src: media.tradesSheet,
    alt: 'Mechanics, construction, HVAC, plumbing, electrical and trucking workers wearing the X1',
    caption: 'Built for the ones who keep America working.',
  },
]

/** One coverage sentence, used word for word everywhere coverage is explained. */
export const WARRANTY_LINE =
  'Lifetime replacement included with every multi-pack. Single systems include 1-year coverage, or add Lifetime for $19.95. The $29.95 Essential includes 30-day basic coverage.'

/** One shipping sentence, used word for word everywhere shipping is explained. */
export const SHIPPING_LINE = 'Free U.S. shipping on every order.'

export const heroChips: string[] = [
  'Wave-on motion sensor. Hands-free on and off',
  '800 lumens · 3 brightness modes',
  'Only 1.4 oz, lighter than safety glasses',
  'Clear lens',
  'Amber lens',
  'Smoke lens',
  'Built-in illumination',
  'USB-C rechargeable',
  'Lifetime replacement',
]

export interface Review {
  name: string
  trade: string
  bought: string
  quote: string
  avatar: string
}

export const reviewSummary = {
  rating: '4.9',
  reviewCount: '18,412',
  sold: '50,000+',
  fiveStarShare: '96%',
}

export const ratingBreakdown: { stars: number; percent: number }[] = [
  { stars: 5, percent: 96 },
  { stars: 4, percent: 3 },
  { stars: 3, percent: 1 },
  { stars: 2, percent: 0 },
  { stars: 1, percent: 0 },
]

export const reviews: Review[] = [
  {
    name: 'Mike R.',
    trade: 'Diesel mechanic · Texas',
    bought: 'Bought the 3-pack',
    quote:
      'Nineteen years of holding a flashlight in my teeth. First night with the X1 I did a fuel filter swap in the dark without asking anyone to hold a light. Then I ordered two more for my guys.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/bc5295c2-a272-4a62-8270-d8007db27b68.jpg',
  },
  {
    name: 'Derek H.',
    trade: 'Site foreman · Ohio',
    bought: 'Bought the crew pack',
    quote:
      'Bought six for the crew. Nobody fights over the work light anymore. One got run over by a skid steer, they replaced it free. That sold me harder than the product did.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0d63d5c4-9ea8-4df4-8e27-f62ced2dfe3c.jpg',
  },
  {
    name: 'Travis M.',
    trade: 'HVAC tech · Arizona',
    bought: 'Bought the 3-pack',
    quote:
      'Attics, crawlspaces, dark closets all day. Amber lens in the dust, clear the rest of the time. My headlamp has been sitting in the van untouched since June.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/06ae3fed-c93e-4505-a899-1651b9595043.jpg',
  },
  {
    name: 'Ray K.',
    trade: 'Long-haul driver · Tennessee',
    bought: 'Bought the 3-pack',
    quote:
      'Chained up on the shoulder at 2am in the rain. Both hands working, light right where I was looking. Worth every dollar just for that one night.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/047d6322-e818-4aa6-a27f-10aa50cb097c.jpg',
  },
  {
    name: 'Shane P.',
    trade: 'Electrician · Pennsylvania',
    bought: 'Bought 1, came back for 3',
    quote:
      'Bought one to test it. Two weeks later I bought the 3-pack. One in the van, one in the shop, one at the house. Reading panels in a dark basement is a different job now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6c1fb60e-874e-493d-b4c2-d68cf7bbf4c0.jpg',
  },
  {
    name: 'Marcus A.',
    trade: 'Master plumber · Illinois',
    bought: 'Bought the crew pack',
    quote:
      'Under sinks and in crawlspaces you are always fighting for light. Now I just look at the fitting and it is lit. Six in the shop, one per truck.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/c546e933-dcdc-4e02-bde7-69061e8cd7e4.jpg',
  },
  {
    name: 'Bill T.',
    trade: 'Roofer · Georgia',
    bought: 'Bought the 3-pack',
    quote:
      'Smoke lens at noon, clear when we button up at dusk. Thirty years on roofs and this is the first piece of new gear that actually changed my day.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/2275cd22-ddad-4d3a-869c-738c89f640f3.jpg',
  },
  {
    name: 'Kevin L.',
    trade: 'CNC machinist · Michigan',
    bought: 'Bought the 3-pack',
    quote:
      'Setting tools inside a machine enclosure used to mean a magnet light and a lot of cussing. Light follows my eyes now. Ordered a set for my brother.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/fde294a4-efd5-4b85-b9a8-e7bb2f0a5db6.jpg',
  },
  {
    name: 'Jess C.',
    trade: 'Welder / fabricator · Colorado',
    bought: 'Bought 1, came back for 3',
    quote:
      'Fit-up work in a dark corner of the shop is where this shines. Light on the joint, both hands on the clamp. Bought two more the same week.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/e9720eca-ce47-46b9-81c4-3d7667513eba.jpg',
  },
  {
    name: 'Hector V.',
    trade: 'Auto body tech · California',
    bought: 'Bought the 3-pack',
    quote:
      'Checking panel gaps and sanding lines, the side light shows every wave. Amber lens under the booth lights is the move. One lives in my box now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/cfc1d75f-1c5b-4b8b-ba2a-303d798acdb6.jpg',
  },
  {
    name: 'Mike D.',
    trade: 'Fleet mechanic · Missouri',
    bought: 'Bought the crew pack',
    quote:
      'Six trucks, six techs, six X1. Shop light bill went down and the dumb questions about "who has the drop light" went away completely.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/050a907d-25b4-497d-b4ac-b26f6635f4c1.jpg',
  },
  {
    name: 'Andre W.',
    trade: 'General contractor · New York',
    bought: 'Bought the 3-pack',
    quote:
      'Punch lists after dark used to end the day early. Not anymore. And the lifetime replacement means I do not baby it. I just use it.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/77f61b0b-0a2c-43d6-afd8-f07a0cee22e9.jpg',
  },
  {
    name: 'Luis M.',
    trade: 'HVAC service · Florida',
    bought: 'Bought the 3-pack',
    quote:
      'Four calls a day in attics that feel like an oven. Hands free, light on the wiring, in and out faster. My apprentice stole mine so I ordered three.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0906c340-5965-476a-aa46-d24445fbac3e.jpg',
  },
  {
    name: 'Katie B.',
    trade: 'Electrician · Washington',
    bought: 'Bought the 3-pack',
    quote:
      'No strap means no headache at the end of a ten hour day, and my hair stays out of it. Panels I used to shoot with a phone light I just read now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/090e3d0d-7bd9-4fce-abbe-9468e7df733d.jpg',
  },
  {
    name: 'Jamal S.',
    trade: 'Electrical apprentice · Illinois',
    bought: 'Bought 1, came back for 3',
    quote:
      'First tool I bought with my own money that the journeymen kept borrowing. So I got the 3-pack and stopped lending mine out.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/168baff4-0756-4969-a9de-75f4b0ad66be.jpg',
  },
  {
    name: 'Ramon G.',
    trade: 'Concrete foreman · Nevada',
    bought: 'Bought the crew pack',
    quote:
      'Early pours start in the dark. Six of these on the crew and we are laying line at 4am like it is noon.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9a66aacd-84fb-41a5-930d-564431e1a283.jpg',
  },
  {
    name: 'Dale F.',
    trade: 'Welder · Wisconsin',
    bought: 'Bought the 3-pack',
    quote:
      'Fit-up, grinding, layout. Light is on the work, not the ceiling. Dropped one on a steel table and it kept going.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/75697599-ffa6-4238-9697-e0543ba5fa5f.jpg',
  },
  {
    name: 'Tom B.',
    trade: 'Power lineman · Oklahoma',
    bought: 'Bought the crew pack',
    quote:
      'Storm restoration at 3am in the bucket. Hands on the hot stick, light exactly where I am looking. Whole crew runs them now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/49a26e93-eb42-4ee5-8512-aed091fed581.jpg',
  },
  {
    name: 'Amit P.',
    trade: 'Facilities maintenance · New Jersey',
    bought: 'Bought the 3-pack',
    quote:
      'Boiler rooms, ceiling tiles, electrical closets. One in the cart, one in the office, one at home. Best forty bucks in my toolbag.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/7ca118fa-f067-42c5-8e1b-dcbed51a0d94.jpg',
  },
  {
    name: 'Dave W.',
    trade: 'HVAC service · Kentucky',
    bought: 'Bought the 3-pack',
    quote:
      'Keep one clipped to the visor in the van. Pull into a call, put it on, walk in ready. Simple as that.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/7c8ab81b-ce5f-439a-b4b9-39d30b13ba89.jpg',
  },
  {
    name: 'Terrance J.',
    trade: 'Diesel mechanic · Alabama',
    bought: 'Bought the crew pack',
    quote:
      'Brake jobs under a trailer are all feel and no light. Not anymore. Bought six so nobody in the bay is without one.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f68b47a3-9546-4979-84e4-4fe7511bc7cf.jpg',
  },
  {
    name: 'Curtis B.',
    trade: 'Plumber · Indiana',
    bought: 'Bought the 3-pack',
    quote:
      'Crawlspaces are the worst part of this job. First time I went under with both hands free I actually laughed.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0aa6798d-a6ad-46d4-aebf-cb704ca244c1.jpg',
  },
  {
    name: 'Mariela R.',
    trade: 'Project engineer · Texas',
    bought: 'Bought the crew pack',
    quote:
      'Walking punch lists at dusk with a tablet in one hand. I stopped carrying a flashlight entirely. Ordered a set for the field team.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/395ce8f4-9626-4818-b3cc-574cd1502227.jpg',
  },
  {
    name: 'Walt H.',
    trade: 'Farmer · Iowa',
    bought: 'Bought the 3-pack',
    quote:
      'Fixing a combine at 10pm during harvest is not optional. This thing paid for itself the first night.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a5cc5147-554e-4328-a97b-6f9fdd15e34b.jpg',
  },
  {
    name: 'Cody M.',
    trade: 'Auto detailer · Utah',
    bought: 'Bought the 3-pack',
    quote:
      'Side light shows swirls my shop lights hide. Caught two panels I would have handed back unfinished.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6e640b19-7557-47d6-a848-bbf5a0a8f9df.jpg',
  },
  {
    name: 'Danielle O.',
    trade: 'HVAC technician · Maryland',
    bought: 'Bought 1, came back for 3',
    quote:
      'Mechanical rooms are never lit right. Bought one, my partner took it, bought three more the same week.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/075c25fa-89f2-4f79-8d27-436d4a56a278.jpg',
  },
  {
    name: 'Ernesto D.',
    trade: 'Landscaper · Arizona',
    bought: 'Bought the 3-pack',
    quote:
      'Smoke lens all summer, then the light for irrigation repairs after sundown. Two tools, one pair of glasses.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/8d9a19d9-4e03-4e52-97ce-702c1114de8b.jpg',
  },
  {
    name: 'Greg S.',
    trade: 'Low-voltage tech · Oregon',
    bought: 'Bought the 3-pack',
    quote:
      'Back of a server rack is a black hole. Punching down cable with light on the block instead of on my forehead is night and day.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/06beede9-b44f-4691-bb2e-f91dbfab5fab.jpg',
  },
  {
    name: 'Randy P.',
    trade: 'Marine mechanic · Florida',
    bought: 'Bought the crew pack',
    quote:
      'Engine compartments on boats are tight, wet and dark. Dropped mine in the bilge, they replaced it free. No argument.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9f195893-1224-48bb-815b-131daa69568d.jpg',
  },
  {
    name: 'Austin K.',
    trade: 'Tow operator · Kansas',
    bought: 'Bought the 3-pack',
    quote:
      'Hooking up on the shoulder at 2am in the rain. Both hands on the chains and the light is on the hook. Safer, period.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a1e0bdc9-e2e7-47f2-bada-ea8760d4f518.jpg',
  },
  {
    name: 'Renato B.',
    trade: 'Aircraft maintenance · Washington',
    bought: 'Bought the crew pack',
    quote:
      'Inspection panels and wire bundles all day. The narrow side beam is exactly what you want inside a wing.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/d9b7ae08-1532-484d-838b-eb9eef8dfa1a.jpg',
  },
  {
    name: 'Gary N.',
    trade: 'Cabinet maker · Vermont',
    bought: 'Bought the 3-pack',
    quote:
      'Fitting hinges inside a dark carcass used to mean a clamp light in the way. Now it is just me and the screw.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/e38779d1-9826-48ff-b190-ac4357ccef5f.jpg',
  },
  {
    name: 'Yvette C.',
    trade: 'Owner-operator · Arkansas',
    bought: 'Bought the 3-pack',
    quote:
      'Pre-trip in the dark at a truck stop, checking tires and lines alone. This is the first thing I grab now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/91572965-8455-468e-ab45-7be0e2be839b.jpg',
  },
  {
    name: 'Stan L.',
    trade: 'Small engine repair · Minnesota',
    bought: 'Bought the crew pack',
    quote:
      'Forty years squinting at carburetors. My eyes are not what they were, but with this I can see the jet again.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/068199c3-af7c-43a9-9c76-c73da5fcc744.jpg',
  },
]

export const reviewStats: { value: string; label: string }[] = [
  { value: '4.9/5', label: 'Average rating' },
  { value: '50,000+', label: 'X1 shipped across America' },
  { value: '18,412', label: 'Verified reviews' },
  { value: '96%', label: 'Five-star ratings' },
]

export const benefitStrip: string[] = [
  '800 lumens',
  'Wave-on motion sensor',
  'USB-C rechargeable',
  'Only 1.4 oz',
  '3 interchangeable lenses',
  'Lifetime replacement on multi-packs',
]

export interface GuaranteePoint {
  title: string
  body: string
  icon: 'hammer' | 'lens' | 'repeat' | 'wallet'
}

export const guaranteePoints: GuaranteePoint[] = [
  {
    title: 'Break it on the job',
    body: 'Dropped off a ladder, run over in the shop, crushed in the toolbox. We replace it.',
    icon: 'hammer',
  },
  {
    title: 'Crack or scratch a lens',
    body: 'Clear, Amber or Smoke. Tell us which one and a new lens ships out.',
    icon: 'lens',
  },
  {
    title: 'For life. Not 30 days',
    body: `${WARRANTY_LINE} No registration games. One email and it is handled.`,
    icon: 'repeat',
  },
  {
    title: 'You never pay for it twice',
    body: 'Buy the X1 once. Keep working with it forever. That is the whole deal.',
    icon: 'wallet',
  },
]

export const oldWay: string[] = [
  'Flashlight in your mouth',
  'Headlamp strapped around your head',
  'Constantly repositioning your light',
]

export interface ComparisonRow {
  point: string
  others: string
  gritVue: string
}

export const comparison: ComparisonRow[] = [
  {
    point: 'Where the light goes',
    others: 'Above your eyes, so the beam misses the work',
    gritVue: 'At eye level, so light follows your line of sight',
  },
  {
    point: 'Turning it on',
    others: 'Fumble for a button with greasy gloves on',
    gritVue: 'Wave your hand. The motion sensor turns it on and off',
  },
  {
    point: 'Brightness',
    others: '200 to 400 lumens, aimed wherever the strap sits',
    gritVue: '800 lumens, aimed exactly where you look',
  },
  {
    point: 'Power',
    others: 'Disposable batteries you keep buying and swapping',
    gritVue: 'Built-in battery, recharges over USB-C with the cable included',
  },
  {
    point: 'Weight on you',
    others: '3 to 5 oz strapped around your head',
    gritVue: '1.4 oz, lighter than your safety glasses',
  },
  {
    point: 'Eye protection',
    others: 'A second piece of gear you buy separately',
    gritVue: 'Built into the same frame',
  },
  {
    point: 'Lens options',
    others: 'One tint, or none at all',
    gritVue: '3 interchangeable lenses: Clear, Amber, Smoke',
  },
  {
    point: 'How you wear it',
    others: 'Strap around your head or hard hat',
    gritVue: 'Wears like glasses. No strap.',
  },
  {
    point: 'Hands on the job',
    others: 'One hand on the flashlight',
    gritVue: 'Both hands free, always',
  },
  {
    point: 'Charging',
    others: 'Batteries or a proprietary cable',
    gritVue: 'USB-C cable included in the box',
  },
  {
    point: 'If it breaks',
    others: 'Buy another one',
    gritVue: 'Break it. We replace it.',
  },
  {
    point: 'What it costs you',
    others: 'Headlamp + glasses + spare lenses, bought separately',
    gritVue: 'Build yours from $29.95, or $23.33 per X1 in the Crew Pack',
  },
]

export interface ValueRow {
  item: string
  note: string
  price: string
}

export const valuePriced: ValueRow[] = [
  { item: 'GritVue X1™ with 1 lens', note: 'The X1 Essential: illuminated frame and one lens', price: '$29.95' },
  { item: 'The other 2 interchangeable lenses', note: 'Full Lens System: Clear + Amber + Smoke', price: '$9.95' },
  { item: 'Hard protective case (AV8)', note: 'Toolbag and truck ready', price: '$14.95' },
  { item: 'Protective pouch', note: 'For spare lenses', price: '$6.95' },
  { item: 'Cleaning cloth', note: 'Streak-free lens care', price: '$4.95' },
  { item: 'Charging cable', note: 'Recharge anywhere', price: 'Included' },
  { item: 'GritVue Quick Start Guide', note: 'Up and running in minutes', price: 'Included' },
  {
    item: 'Lifetime replacement warranty',
    note: 'Free with every multi-pack. Single system: 1-year coverage, or add Lifetime for $19.95',
    price: '$19.95',
  },
]

export const valueTotals = {
  total: '$86.70',
  /** Essential + Full Lens System + hard case, bought piece by piece in the builder. */
  builtSeparately: '$54.85',
  payOne: '$49.95',
  saveVsBuilt: '$4.90',
  payEach: '$33.30',
}

export const newWay: string[] = [
  'Light follows your line of sight',
  'Wears like glasses',
  'Three lens options',
  'Both hands stay on the job',
]

export interface Lens {
  name: string
  use: string
  body: string
  swatch: string
}

export const lenses: Lens[] = [
  {
    name: 'Clear',
    use: 'Everyday work',
    body: 'For garages, shops, indoor projects and general use.',
    swatch: 'rgba(244,244,240,0.55)',
  },
  {
    name: 'Amber',
    use: 'Low-light contrast',
    body: 'A different visual option for lower-light work environments.',
    swatch: 'rgba(243,196,0,0.85)',
  },
  {
    name: 'Smoke',
    use: 'Bright conditions',
    body: 'For outdoor and bright daytime environments.',
    swatch: 'rgba(48,52,58,0.95)',
  },
]

export const useCases: string[] = [
  'Mechanics',
  'Oil & Gas',
  'HVAC',
  'Plumbing',
  'Electrical',
  'Welding',
  'Pipefitting',
  'Construction',
  'Roofing',
  'Diesel & Fleet',
  'Refinery',
  'Trucking',
  'Farm & Ranch',
  'DIY',
  'Outdoors',
]

export const useCaseLines: string[] = [
  'Under a hood.',
  'Inside a crawlspace.',
  'Behind a dashboard.',
  'On a rig at 4am.',
  'On a roof.',
  'Inside a cabinet.',
  'At the jobsite after dark.',
]

export interface Detail {
  title: string
  body: string
  icon: 'lightbulb' | 'layers' | 'usb' | 'hands' | 'box' | 'battery' | 'glasses'
}

export const details: Detail[] = [
  { title: 'Built-in illumination', body: '800 lumens aimed right where you look.', icon: 'lightbulb' },
  { title: '3 interchangeable lenses', body: 'Clear. Amber. Smoke.', icon: 'layers' },
  { title: 'USB-C rechargeable', body: 'Full charge in about 2.5 hours. About 3h 20m of light.', icon: 'usb' },
  { title: 'Battery display', body: 'Digital readout tells you exactly what you have left.', icon: 'battery' },
  {
    title: 'Prescription ready',
    body: 'Take it to your optical professional for a custom prescription setup.',
    icon: 'glasses',
  },
  { title: 'Hands-free design', body: 'No handheld flashlight required.', icon: 'hands' },
  {
    title: 'Wave-on motion sensor',
    body: 'Wave your hand to turn the light on and off. No hunting for the button, gloves stay on.',
    icon: 'hands',
  },
  { title: 'Tool-free lens swap', body: 'Pop one lens out, snap the next in. No screws, no tools.', icon: 'layers' },
  { title: 'Compact', body: 'Keep it in your toolbox, truck, garage or work bag.', icon: 'box' },
]

export interface Offer {
  id: 'single' | 'trio' | 'crew'
  eyebrow?: string
  kicker?: string
  name: string
  units: string
  price: string
  compareAt?: string
  save?: string
  perUnit?: string
  /** The one line that should hit hardest on the card. */
  highlight?: string
  /** Combined-runtime claim, always paired with the footnote. */
  runtime?: string
  footnote?: string
  splitNote?: { title: string; body: string; each: string }
  mysteryGift?: boolean
  freeShipping: boolean
  note: string
  supporting: string[]
  includes: string[]
  cta: string
  badge?: string
  featured: boolean
  /** Product photo shown above the price. Add one per pack as photos arrive. */
  image?: string
  imageAlt?: string
  /** Key in PRODUCT_LINKS (data/productLinks.ts). The pack button goes to that Shopify cart with the chosen quantity. */
  link: ProductLinkKey
  /** Short discount chip shown beside the price, e.g. "Save $30". */
  discountBadge?: string
}

/** The complete system every X1 ships as, used in cards and the value stack. */
export const completeSystem = (n: number): string[] => {
  const q = (label: string, plural = label + 's') => (n === 1 ? `1 ${label}` : `${n} ${plural}`)
  return [
    q('GritVue X1™ Illuminated Work Glasses', 'GritVue X1™ Illuminated Work Glasses'),
    n === 1 ? '3 interchangeable lenses: Clear, Amber, Smoke' : `${n * 3} interchangeable lenses: ${n} each Clear, Amber, Smoke`,
    q('hard protective case (AV8)', 'hard protective cases (AV8)'),
    q('protective pouch', 'protective pouches'),
    q('cleaning cloth'),
    q('charging cable'),
    q('GritVue Quick Start Guide', 'GritVue Quick Start Guides'),
    // Lifetime coverage is a multi-pack benefit; the single system carries 1 year.
    n === 1 ? '1-year replacement coverage' : 'Lifetime Replacement Warranty',
  ]
}

export const offers: Offer[] = [
  {
    id: 'single',
    link: 'singleX1',
    image: 'https://cdn.magicpatterns.com/uploads/oGLK2WHHQfutz2dq7y8qx1/830092C6-FF0A-46DC-A55D-047708A86A51.png',
    imageAlt:
      '1 GritVue X1 complete system for $49.95: illuminated X1 frame with Clear, Amber and Smoke lenses',
    kicker: 'Single system',
    name: '1 GritVue X1 Complete System',
    units: '1 complete system',
    price: '$49.95',
    freeShipping: true,
    note: 'Free U.S. shipping.',
    supporting: ['Wave-on motion sensor. Hands-free on and off.'],
    includes: completeSystem(1),
    cta: 'Get the X1 — $49.95',
    featured: false,
  },
  {
    id: 'trio',
    link: 'threeX1Public9990',
    image: 'https://cdn.magicpatterns.com/uploads/ewi33fmt4rTNo3vDL3FeC7/27B38BF2-731F-45B5-8025-350EBD24AE66.png',
    imageAlt:
      'Most popular: Buy 2 get 1 free. 3 GritVue X1 complete systems for $99.90, only $33.30 each',
    eyebrow: 'Most popular',
    kicker: 'Buy 2, get 1 free',
    name: '3 Complete Systems',
    units: '3 GritVue X1 complete systems',
    price: '$99.90',
    compareAt: '$149.85',
    save: 'Save $49.95',
    perUnit: 'Only $33.30 per X1',
    highlight: 'Buy 2. Get 1 free.',
    runtime: 'One working. One ready. One backup.',
    footnote:
      'Take 2 and we give you the 3rd free. Lifetime replacement included on all 3: break one, we send you another. Free U.S. shipping. Terms apply.',
    splitNote: {
      title: 'Work with a crew?',
      body: 'Split the pack with two coworkers.',
      each: 'Only $33.30 each when split evenly.',
    },
    mysteryGift: true,
    freeShipping: true,
    note: 'Free U.S. shipping.',
    supporting: ['Every X1 is a complete system, including the free one.'],
    includes: [...completeSystem(3), 'Free mystery gift'],
    cta: 'Get 3 X1 Systems — $99.90',
    featured: true,
  },
  {
    id: 'crew',
    link: 'sixX1Public17990',
    image: 'https://cdn.magicpatterns.com/uploads/6H5qQQ6AUSeVQzDt1DwAfb/57E3A69A-BEF0-4D2F-AD92-B5D7A7403CB8.png',
    imageAlt: 'Buy 4 get 2 free. 6 GritVue X1 complete systems for $179.90, only $29.98 each',
    eyebrow: 'Best value',
    kicker: 'Buy 4, get 2 free',
    name: '6 Complete Systems',
    units: '6 GritVue X1 complete systems',
    price: '$179.90',
    compareAt: '$299.70',
    save: 'Save $119.80',
    perUnit: 'Only $29.98 per X1',
    highlight: 'Buy 4. Get 2 free.',
    footnote:
      'Take 4 and we give you 2 more free. Lifetime replacement included on all 6: break one, we send you another. Free U.S. shipping. Terms apply.',
    mysteryGift: true,
    freeShipping: true,
    note: 'Free U.S. shipping.',
    supporting: ['More systems. Lower cost per X1.', 'Every unit is a complete system.'],
    includes: [...completeSystem(6), 'Free mystery gift'],
    cta: 'Get 6 X1 Systems — $179.90',
    featured: false,
  },
]

/**
 * What ships with each way to buy, shown side by side so nobody assumes the
 * $29.95 Essential includes everything. Multi-packs are Complete Systems.
 */
export type GearStatusKind = 'included' | 'addon' | 'none'

export interface GearStatus {
  kind: GearStatusKind
  label: string
}

export interface GearItem {
  name: string
  note: string
  image?: string
  essential: GearStatus
  complete: GearStatus
  packs: GearStatus
  /** Opens the warranty & protection terms. */
  termsLink?: boolean
  /** Lets the customer add this to an X1 Essential right from the table. */
  quickAdd?: QuickAddId
}

export type QuickAddId = 'fullLens' | 'hardCase' | 'careKit' | 'rx' | 'lifetime'

export const gearColumns = [
  { key: 'essential', title: 'X1 Essential', price: 'From $29.95' },
  { key: 'complete', title: 'Complete System', price: '$49.95' },
  { key: 'packs', title: 'Multi-packs', price: 'From $99.90' },
] as const

const inc = (label = 'Included'): GearStatus => ({ kind: 'included', label })
const add = (label: string): GearStatus => ({ kind: 'addon', label })
const none: GearStatus = { kind: 'none', label: 'Not included' }

export const includedGear: GearItem[] = [
  {
    name: 'GritVue X1',
    note: 'Illuminated frame with the motion sensor and USB-C charging.',
    image: media.x1Smoke,
    essential: inc(),
    complete: inc(),
    packs: inc('One per system'),
  },
  {
    name: 'Clear, Amber, Smoke lenses',
    note: 'Interchangeable and tool-free. Swap to match the job.',
    image: media.lensSet,
    quickAdd: 'fullLens',
    essential: inc('1 lens of your choice · other 2 for +$9.95'),
    complete: inc('All 3 lenses'),
    packs: inc('All 3 per system'),
  },
  {
    name: 'USB-C charging cable',
    note: 'Charges the X1 from any USB power source.',
    image: media.cable,
    essential: inc(),
    complete: inc(),
    packs: inc('One per system'),
  },
  {
    name: 'GritVue Quick Start Guide',
    note: 'Up and running in minutes. Also online, step by step.',
    image: media.guideCover,
    essential: inc(),
    complete: inc(),
    packs: inc('One per system'),
  },
  {
    name: 'Hard Protective Case AV8',
    note: 'Keeps the frame and lenses safe in the toolbag or truck.',
    image: media.hardCase,
    quickAdd: 'hardCase',
    essential: add('Add-on · +$14.95'),
    complete: inc(),
    packs: inc('One per system'),
  },
  {
    name: 'Protective pouch + cleaning cloth',
    note: 'Soft pouch and a microfiber cloth for the lenses.',
    image: media.pouchCloth,
    essential: none,
    complete: inc(),
    packs: inc('One set per system'),
  },
  {
    name: 'Anti-Fog Care Kit',
    note: 'Anti-fog lens care spray and a microfiber cloth.',
    image: media.careKit,
    quickAdd: 'careKit',
    essential: add('Add-on · +$7.95'),
    complete: add('Add-on · +$7.95'),
    packs: add('+$7.95 each, as many as you need'),
  },
  {
    name: 'RX Capability Insert',
    note: 'Removable insert that fits behind the main lens. Prescription lenses not included.',
    image: media.rxInsert,
    quickAdd: 'rx',
    essential: add('Add-on · +$14.95'),
    complete: add('Add-on · +$14.95'),
    packs: add('Add-on · +$14.95 each'),
  },
  {
    name: 'Replacement coverage',
    note: 'Break it. We replace it. Terms apply.',
    termsLink: true,
    quickAdd: 'lifetime',
    essential: inc('30-day basic · 1-year or Lifetime add-on'),
    complete: inc('1 year · Lifetime for +$19.95'),
    packs: inc('Lifetime on every X1'),
  },
  {
    name: 'Mystery gift',
    note: "Something extra in the box. No extra charge, while supplies last.",
    image: media.mysteryBox,
    essential: none,
    complete: none,
    packs: inc('3- and 6-packs'),
  },
]

export const companyPack = {
  link: 'thirtyX1Public69990' as ProductLinkKey,
  image: 'https://cdn.magicpatterns.com/uploads/4pGr5NtdUvfwLKyZpPYeNw/0EEE3B9C-D2CE-40C2-933C-C55049707DE7.png',
  imageAlt: 'Best bulk value: Buy 20 get 10 free. 30 GritVue X1 complete systems for $699.90, only $23.33 each',
  topBadge: 'For business owners & work crews',
  secondaryBadge: 'Best bulk value',
  title: 'Business / Crew Pack',
  offer: 'Buy 20. Get 10 free.',
  units: '30 GritVue X1 complete systems',
  priceValue: 699.9,
  compareValue: 1498.5,
  saveValue: 798.6,
  price: '$699.90',
  perUnit: '$23.33 per X1',
  savings: 'You save $798.60',
  comparison: '30 single Complete Systems at $49.95: $1,498.50',
  headline: 'The smarter way to outfit your entire crew.',
  subheadline: '30 complete systems for $23.33 each.',
  copy: 'One crew. One order. 30 complete, work-ready systems. Built for the people who keep the job moving, priced for the owners who buy for all of them.',
  cta: 'Outfit your crew — get 30 for $699.90',
  ctaNote: 'One crew. One order. 30 complete systems.',
  includes: [
    '30 GritVue X1™ Illuminated Work Glasses',
    '90 interchangeable lenses: 30 Clear, 30 Amber, 30 Smoke',
    '30 hard protective cases (AV8)',
    '30 protective pouches',
    '30 cleaning cloths',
    '30 charging cables',
    '30 GritVue Quick Start Guides',
    'Free U.S. shipping',
    'Lifetime Replacement Warranty for eligible systems while the warranty promotion is active',
  ],
}

export const valueStack: string[] = [
  'GritVue X1™ Illuminated Work Glasses',
  'Clear, Amber and Smoke interchangeable lenses',
  'Hard protective case (AV8)',
  'Protective pouch and cleaning cloth',
  'Charging cable',
  'GritVue Quick Start Guide',
  '1-year replacement coverage (Lifetime on multi-packs)',
]

export interface BundleReason {
  title: string
  body: string
  icon: 'toolbox' | 'truck' | 'garage' | 'crew'
}

export const bundleReasons: BundleReason[] = [
  { title: 'Toolbox', body: 'Keep one with your tools.', icon: 'toolbox' },
  { title: 'Truck', body: 'Never leave home without one.', icon: 'truck' },
  { title: 'Garage', body: 'Always have one ready.', icon: 'garage' },
  { title: 'Crew / gift', body: "Give one to the guy who's always borrowing your gear.", icon: 'crew' },
]

export interface Assurance {
  title: string
  body: string
  icon: 'ship' | 'clock' | 'return' | 'infinity'
}

export const assurances: Assurance[] = [
  {
    title: 'Shipped USPS from the U.S.',
    body: 'Every order leaves one of our U.S. warehouses insured and tracked. No overseas wait, no customs surprises.',
    icon: 'ship',
  },
  {
    title: 'Delivered in 3 to 6 business days',
    body: 'Orders placed before 2pm CT ship the same business day, with USPS tracking emailed to you.',
    icon: 'clock',
  },
  {
    title: '30-day returns, no questions',
    body: "Don't like it? Send it back within 30 days for a refund. See our returns policy for details.",
    icon: 'return',
  },
  {
    title: 'Lifetime replacement on multi-packs',
    body: `Break it, crack it, scratch a lens. We replace it. ${WARRANTY_LINE} Terms apply.`,
    icon: 'infinity',
  },
]

export const shippingNote =
  'Shipped USPS, insured and tracked. Free standard U.S. shipping on every order.'

export interface Spec {
  label: string
  value: string
}

/**
 * Only claims GritVue can stand behind for this production model. Add runtime,
 * charge time and weight here once they are measured — nothing is invented.
 */
export const performance: { value: string; label: string; note: string }[] = [

  {
    value: 'Wave',
    label: 'Motion sensor on/off',
    note: 'Wave your hand in front of the sensor and the light turns on or off. No hunting for the button with gloves on.',
  },
  {
    value: '800',
    label: 'Lumens',
    note: 'Dual LED output aimed at your line of sight. Low, medium and high modes.',
  },
  {
    value: '3h 20m',
    label: 'Runtime',
    note: 'About 3 hours 20 minutes per full charge. Varies by light mode and use.',
  },
  {
    value: '2.5 hrs',
    label: 'Full charge',
    note: 'USB-C from empty to full in about 2.5 hours.',
  },
  {
    value: '1.4 oz',
    label: 'Weight',
    note: 'Lighter than your safety glasses. Nothing on your head, nothing on your neck.',
  },
]

export const specs: Spec[] = [
  {
    label: 'Motion sensor',
    value:
      'Wave your hand in front of the sensor to turn the light on and off. No hunting for the button with gloves on, greasy hands or full hands.',
  },
  {
    label: 'Power button',
    value: 'On the left side, next to the LEDs. Hold 2 seconds to turn on or off; press to cycle low, medium and high.',
  },
  { label: 'Brightness', value: '800 lumens from dual LED modules, with 3 brightness modes (low, medium, high)' },
  { label: 'Runtime', value: 'About 3 hours 20 minutes per full charge, varies by light mode and use' },
  { label: 'Charge time', value: 'About 2.5 hours to full over USB-C' },
  { label: 'Weight', value: '1.4 oz (40 g), lighter than most safety glasses' },
  { label: 'Light', value: 'Dual LED modules built into the frame, aimed at your line of sight' },
  { label: 'Charging', value: 'USB-C, the same cable as your phone. Cable included.' },
  {
    label: 'Lenses',
    value:
      '3 interchangeable: Clear, Amber, Smoke. The X1 Essential includes 1 of your choice (add the other 2 for $9.95); the Complete System and multi-packs include all 3.',
  },
  { label: 'Lens changes', value: 'Tool-free. Pop one out, snap the next in.' },
  { label: 'Worn like', value: 'Standard work glasses. No head strap, no battery pack.' },
  { label: 'Under a hard hat', value: 'Yes. Wears flat against the temples, nothing on the crown.' },
  {
    label: 'Prescription ready',
    value:
      'Yes. Take your X1 to your trusted optical professional and ask about a custom prescription setup, or add the removable GritVue RX Capability Insert™ for $14.95 (insert only; prescription lenses are fitted by your optical professional).',
  },
  { label: 'Battery display', value: 'Digital readout on the frame shows exactly how much power is left.' },
  { label: 'Coverage', value: '1-year replacement on a single X1, Lifetime on multi-packs or with the Lifetime upgrade · 30-day returns' },
  {
    label: 'In the box',
    value:
      'Depends on what you choose. X1 Essential: X1 glasses, 1 lens of your choice, USB-C charging cable and the Quick Start Guide, plus only the add-ons you select. Complete System (and every X1 in a multi-pack): X1 glasses, Clear + Amber + Smoke lenses, charging cable, hard protective case (AV8), protective pouch, cleaning cloth and the Quick Start Guide. The 3- and 6-packs add a free mystery gift.',
  },
  {
    label: 'Shipping',
    value: 'Ships USPS from our U.S. warehouses. Every order is insured and tracked.',
  },
]

export const discountOffer = {
  eyebrow: 'Before you go',
  headline: '5 off your first X1',
  body: 'Still thinking about it? Take this with you. Works on the standard single X1 ($49.95).',
  code: '5OFF',
  cta: 'Use my code',
  note: 'Code 5OFF applies 5% off the standard single X1 at checkout. One use per customer. Not valid on bundles, Lifetime offers, private or business pricing, and cannot be combined with other discounts or referral rewards.',
}

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'What comes with each GritVue X1?',
    a: 'It depends on how you buy it. The X1 Essential ($29.95) includes the illuminated frame, 1 lens of your choice, a USB-C charging cable and the Quick Start Guide; you add only the extras you want. The X1 Complete System ($49.95) includes the frame, Clear, Amber and Smoke lenses, the hard case, a pouch, a cleaning cloth, the charging cable and the Quick Start Guide. Every X1 in a multi-pack is a Complete System.',
  },
  {
    q: 'Do I get all three lenses?',
    a: 'All three come with every Complete System and every multi-pack. If you build your own X1 Essential, it includes one lens of your choice, and you can add the other two with the Full Lens System for $9.95.',
  },
  {
    q: 'How do I turn the light on?',
    a: 'Hold the power button on the left side, next to the LEDs, for 2 seconds. Or wave your hand in front of the sensor: the built-in motion sensor turns the light on and off, so you do not have to find the button with gloves on or greasy hands.',
  },
  {
    q: 'How bright is it, and how long does it last?',
    a: '800 lumens from dual LED modules with 3 brightness modes: low, medium and high. About 3 hours 20 minutes of light per full charge, depending on the mode. For longer shifts, keep a second X1 charged and swap.',
  },
  {
    q: 'How long does it take to charge?',
    a: 'About 2.5 hours from empty to full over USB-C. Make sure the port and the glasses are completely dry before you plug in the cable.',
  },
  {
    q: 'How heavy is it?',
    a: '1.4 oz (40 g), lighter than most safety glasses. No head strap, no battery pack on your neck.',
  },
  { q: 'Is it rechargeable?', a: 'Yes. GritVue X1 is USB-C rechargeable.' },
  {
    q: 'Is this a headlamp?',
    a: 'No. X1 is worn like glasses, with illumination integrated into the frame.',
  },
  {
    q: 'Can I use it for work?',
    a: 'X1 is designed as illuminated work eyewear for hands-free visibility in a wide range of work and DIY environments.',
  },
  {
    q: 'Can I tell how much battery is left?',
    a: 'Yes. A digital battery display on the frame shows the charge you have left, so you are never guessing before a shift.',
  },
  {
    q: 'What is the Lifetime Replacement Warranty?',
    a: `Break it. We replace it. If your X1 breaks, cracks, stops charging or a lens gets scratched, email us with your order number and we take care of it. The replacement unit is free; a flat $6.95 shipping and handling fee applies per approved replacement claim. ${WARRANTY_LINE} When you build an Essential, you can also add 1-year or Lifetime breakage protection. Terms apply.`,
  },
  {
    q: 'How fast do you ship, and where from?',
    a: `Every order ships from one of our U.S. warehouses. Orders placed before 2pm CT go out the same business day and arrive in 3 to 6 business days with tracking. ${SHIPPING_LINE}`,
  },
  {
    q: 'What if I just don\u2019t like it?',
    a: 'Send it back within 30 days for a refund. Start it from the return request form in the Owner Center and we send you the instructions. Full details are in our returns policy. The lifetime replacement covers breakage; the 30-day return covers changing your mind.',
  },
  {
    q: 'Can I wear it under a hard hat?',
    a: 'Yes. The X1 wears flat against the temples with nothing on the crown of your head, so a hard hat sits normally.',
  },
  {
    q: 'Can I put my prescription in them?',
    a: 'Yes. Take your X1 to your trusted optical professional and ask about a custom prescription setup, or add the GritVue RX Capability Insert™ for $14.95. It is a removable insert that sits behind the main lens, so your prescription stays in place while you switch Clear, Amber and Smoke. Your optical professional fits your prescription lenses into it; prescription lenses are not included. It is optional and not required to use the X1. Terms apply.',
  },
  {
    q: "What's the best deal?",
    a: 'Want only what you need? Build your own X1 from $29.95: the X1 Essential with one lens of your choice, then add only the extras you want. Want it ready to go? The X1 Complete System is $49.95 with all 3 lenses, the hard case and one-year replacement coverage; add the Lifetime Replacement Warranty for $19.95. Buy 2, Get 1 Free gives you 3 Complete Systems for $99.90, only $33.30 each, lifetime coverage included. Buy 4, Get 2 Free gives you 6 for $179.90, only $29.98 each. The Business / Crew Pack gives you 30 for $699.90, only $23.33 each. Free U.S. shipping on every order.',
  },
]
